/**
 * Auto generated build file to add global access to
 * provided methods
 */

import YearWeekFilterController from './controllers/data-table-week-filter-controller';
import GlobalSearchController from './controllers/global-search-controller';
import QuillEditorController from './controllers/quill-editor-controller';
import MyDiscountsController from './controllers/my-discounts-controller';
import SortingController from './controllers/sorting-checkbox-controller';

Stimulus.register('year-week-filter', YearWeekFilterController);
Stimulus.register('global-search', GlobalSearchController);
Stimulus.register('quill', QuillEditorController);
Stimulus.register('my-discounts', MyDiscountsController);
Stimulus.register('global-sorter', SortingController);

